import script from "./w-Footer.vue?vue&type=script&setup=true&lang=js"
export * from "./w-Footer.vue?vue&type=script&setup=true&lang=js"

import "./w-Footer.vue?vue&type=style&index=0&id=19509a64&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19509a64"]])

export default __exports__